// extracted by mini-css-extract-plugin
module.exports = {"container":"_3yNKoKHDnZxiOrmN8HfTK","cancelBtn":"_2RA_a6_ootp2n7Ji2Z1oR9","icon":"_1eI__WxQ1RPySbYIku5Mbz","saveBtn":"_2d-Jxef3yVqSQZCWw2JjGe"};